export const api = {
	online: process.env.REACT_APP_API,
	// local: 'https://d1l0g9f8i8.execute-api.us-east-2.amazonaws.com/production'
	local: 'https://upperhand.pagekite.me/v1'
}

export const BaseURL = api.online
// export const BaseURL = api.local
